// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"442":"91ffa649","845":"a421b902"}[chunkId] + ".chunk.css";
};